import { ERequestType } from "../../Enum/ERequestType"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { TutorialEntity } from "../../Objects/Tutorial/TutorialEntity"
import { DeleteRequest, PostFormRequest, PutFormRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"

export const useSaveTutorial = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleSaveTutorial = async (tutorial: TutorialEntity, onSuccess: () => void) => {
    enableLoad()

    try {
      const response =
        tutorial.id > 0
          ? await PutFormRequest(API_ROUTES.ADMIN_TUTORIAL.UPDATE(tutorial.id), tutorial.toJSON(), ERequestType.Admin)
          : await PostFormRequest(API_ROUTES.ADMIN_TUTORIAL.CREATE, tutorial.toJSON(), ERequestType.Admin)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess()
    } catch (e) {
      const message = e instanceof Error ? e.message : "Erro ao salvar tutorial."

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  const handleRemoveTutorial = async (id: number, onSuccess: () => void) => {
    enableLoad()

    try {
      const response = await DeleteRequest(API_ROUTES.ADMIN_TUTORIAL.DELETE(id), ERequestType.Admin)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess()
    } catch (e) {
      const message = e instanceof Error ? e.message : "Erro ao remover tutorial."

      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleSaveTutorial, handleRemoveTutorial }
}
